import { useState } from 'react';
import { RadioButtonProps } from './RadioButton.types';
import { QuestionMarkCircle } from '../../../icons/SvgIcons';

function RadioButton({
  label,
  value,
  name,
  checked,
  onChange,
  tooltip
}: RadioButtonProps) {
  const [hovered, setHovered] = useState(false);

  const handleChange = () => {
    onChange(value);
  };

  return (
    <label className="flex items-center gap-2 w-fit cursor-pointer group">
      <div className="relative self-start mt-1">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={handleChange}
          className="sr-only peer"
        />
        <div
          className={`w-4 h-4 rounded-full border ${
            checked
              ? 'bg-purple-600 border-primary-400'
              : 'bg-white border-gray-200 group-focus:ring-2 group-focus:ring-offset-2 group-focus:ring-purple-400 interactive_ring_classes'
          } flex items-center justify-center`}
        >
          {checked && <div className="w-1.5 h-1.5 bg-white rounded-full"></div>}
        </div>
      </div>
      <span className="text-gray-900v2 font-inter font-normal text-base leading-6">
        {label}
      </span>
      {tooltip && (
        <div
          title={tooltip}
          className="mb-2"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {QuestionMarkCircle(hovered)}
        </div>
      )}
    </label>
  );
}

export default RadioButton;
